import React, { Component } from 'react';
import { connect } from 'react-redux';

import Icon from '../../components/uielements/icon';
import appActions from '../../redux/app/actions';
import { AppHolder, Toolbar, IconButtons, TopbarComponents } from './style';
import Typography from '../../components/uielements/typography';
import TopbarUser from './topbarUser';
const { toggleCollapsed } = appActions;

var fruits = [];

class Topbar extends Component {


	render() {
		const { toggleCollapsed, locale, url, customizedTheme, url_path, propsnya } = this.props;
		const propsTopbar = { locale, url , url_path, propsnya};

		switch (url_path) {
			case "/dashboard/":
				fruits = [];
				fruits.push("Dashboard");
			  break;
			case "/dashboard/news-gue-sehat":
				fruits = [];
				fruits.push("Gue sehat");
			  break;
			case "/dashboard/eventlist-home":
				fruits = [];
				fruits.push("List event");
		  }

		return (
			<AppHolder className={"topbar_div"}>
				<Toolbar
					style={{
						paddingLeft: '30px',
						minHeight: '64px',
						background: customizedTheme.topbarTheme,
					}}
				>
					<IconButtons
						id="topbarCollapsed"
						aria-label="open drawer"
						onClick={toggleCollapsed}
						className="right"
					>
						<Icon>menu</Icon>
					</IconButtons>
					<Typography className="topbar" >Portal Mobile DXG</Typography>
					<TopbarComponents>
						<ul className="topbarItems">
							<li className="topbarUser">
								<TopbarUser {...propsTopbar} />
							</li>
						</ul>
					</TopbarComponents>
				</Toolbar>
			</AppHolder>
		);
	}
}

export default connect(
	state => ({
		...state.App,
		locale: state.LanguageSwitcher.language.locale,
		customizedTheme: state.ThemeSwitcher.topbarTheme,
	}),
	{ toggleCollapsed }
)(Topbar);
